module.exports = __webpack_public_path__ + "static/media/morphle-updated-logo.07610a7e.png";